module.exports = __webpack_public_path__ + "img/ícone-biblioteca.f0a7e3a0.svg";